import { useToast } from "@/components/00-Orion.preCORE2";
import { ConfirmDeleteContent } from "@/components/molecules/ConfirmDeleteContent/confirmDeleteContent";

import useNotificationStore, { DialogProps } from "../store/notification.store";

export const useNotificationNamek = () => {
  const { toast: toastOrion } = useToast();
  const showDialog = useNotificationStore((state) => state.showDialog);
  const showConfirm = useNotificationStore((state) => state.showConfirm);

  const errorMultiple = (
    msg: string[],
    options?: Partial<Pick<DialogProps, "title" | "description">>,
  ) => {
    const title = options?.title ?? "No se pudo realizar la acción";
    const description = options?.description ?? "Por favor, revise los siguientes puntos:";
    showDialog({
      title,
      type: "error",
      description: description,
      details: msg,
    });
  };

  return {
    confirm: {
      show: showConfirm,
      ConfirmDeleteContent,
    },
    dialog: {
      show: showDialog,
    },
    toast: { ...toastOrion, errorMultiple },
  };
};
